import { render, staticRenderFns } from "./Simple2.vue?vue&type=template&id=a8b8f8e0&"
import script from "./Simple2.vue?vue&type=script&lang=js&"
export * from "./Simple2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports